import {
  IActivityItemBase,
  IActivityScheduleItemBase,
} from '../../models/activities';
import { IBookingQueueBase } from '../../models/bookingQueues';
import { ISpotModalityBase } from '../../models/spots';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

export interface ICreateBookingQueueProps {
  activityId: string;
  activityScheduleId?: string;
  bookedDate: Date;
  description?: string;
  items?: IActivityItemBase[];
  modalities?: ISpotModalityBase[];
  scheduleItems?: IActivityScheduleItemBase[];
  userId: string;
}

export type INewBookingQueue = IBookingQueueBase;

export const createBookingQueuesService = async ({
  activityId,
  activityScheduleId,
  bookedDate,
  description,
  items,
  modalities,
  scheduleItems,
  userId,
}: ICreateBookingQueueProps): Promise<INewBookingQueue> => {
  const { data } = await jhsfBookingsApi.post<INewBookingQueue>(
    '/booking-queues',
    {
      activityId,
      activityScheduleId,
      bookedDate,
      description,
      items,
      modalities,
      scheduleItems,
      userId,
    },
  );

  return data;
};
